'use client';

import Image from 'next/image';
import { useIntl } from 'react-intl';
import setDenaliAttribute from '../../../../utils/setDenaliAttribute';
import containerBadgeSizeToPx from '../containerBadgeSizeToPx';
import { ContainerBadgeProps } from '../types';
import containerBadgeSrc from './peak-container-badge.svg';

const PeakContainerBadge = ({ className, size = 'md' }: ContainerBadgeProps) => {
  const intl = useIntl();
  return (
    <Image
      {...setDenaliAttribute('SubscriptionBadge')}
      className={className}
      src={containerBadgeSrc}
      height={containerBadgeSizeToPx[size]}
      alt={intl.formatMessage({ defaultMessage: '{tier} badge image' }, { tier: 'Peak' })}
    />
  );
};

export default PeakContainerBadge;
